var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        centered: "",
        "hide-header": "",
        "hide-footer": "",
        "modal-class": "customize-folder-modal",
        "content-class": "customize-folder-modal__content",
        "body-class": "customize-folder-modal__body p-0",
      },
      on: { hide: _vm.closeHandler },
    },
    [
      _c("div", { staticClass: "cfm" }, [
        _c("div", { staticClass: "cfm__header" }, [
          _c("h2", { staticClass: "cfm__title" }, [
            _vm._v("\n        Customize folder\n      "),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "cfm__close",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.$refs.modal.hide()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c("path", { attrs: { d: "M18 6 6 18" } }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "m6 6 12 12" } }),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cfm__preview" }, [
          _c("div", {
            staticClass: "cfm__preview-box",
            domProps: { innerHTML: _vm._s(_vm.previewHtml) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cfm__sections" }, [
          _c("div", { staticClass: "cfm__section" }, [
            _c("div", { staticClass: "cfm__label" }, [
              _vm._v("\n          Color\n        "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cfm__colors" },
              [
                _c("button", {
                  staticClass: "cfm__swatch cfm__swatch--none",
                  class: { "is-selected": !_vm.color },
                  attrs: { type: "button", "aria-label": "No color" },
                  on: {
                    click: function ($event) {
                      _vm.color = null
                    },
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.COLORS, function (swatch) {
                  return _c("button", {
                    key: swatch,
                    staticClass: "cfm__swatch",
                    class: { "is-selected": _vm.color === swatch },
                    style: { backgroundColor: swatch },
                    attrs: { type: "button", "aria-label": swatch },
                    on: {
                      click: function ($event) {
                        _vm.color = swatch
                      },
                    },
                  })
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cfm__section" }, [
            _c("div", { staticClass: "cfm__label" }, [
              _vm._v("\n          Emoji\n        "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cfm__emojis" },
              [
                _c(
                  "button",
                  {
                    staticClass: "cfm__emoji cfm__emoji--none",
                    class: { "is-selected": !_vm.emoji },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.selectEmoji(null)
                      },
                    },
                  },
                  [_vm._v("\n            —\n          ")]
                ),
                _vm._v(" "),
                _vm._l(_vm.EMOJIS, function (option) {
                  return _c(
                    "button",
                    {
                      key: option,
                      staticClass: "cfm__emoji",
                      class: { "is-selected": _vm.emoji === option },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.selectEmoji(option)
                        },
                      },
                    },
                    [_vm._v("\n            " + _vm._s(option) + "\n          ")]
                  )
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.customEmoji,
                      expression: "customEmoji",
                    },
                  ],
                  staticClass: "cfm__custom",
                  attrs: {
                    type: "text",
                    placeholder: "Custom",
                    maxlength: "2",
                  },
                  domProps: { value: _vm.customEmoji },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.customEmoji = $event.target.value
                      },
                      _vm.onCustomEmojiInput,
                    ],
                  },
                }),
              ],
              2
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cfm__footer" }, [
          _c(
            "button",
            {
              staticClass: "cfm__btn cfm__btn--cancel",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$refs.modal.hide()
                },
              },
            },
            [_vm._v("\n        Cancel\n      ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "cfm__btn cfm__btn--save",
              attrs: { type: "button", disabled: _vm.saving },
              on: { click: _vm.accept },
            },
            [_vm._v("\n        Save\n      ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }